import {
  requestJson,
} from '../../../shared/api/apiClient';


const CHECK_LOGIN_ID_ENDPOINT =
  '/api/signup/checkLoginId';

const SALES_REPRESENTATIVE_LIST_ENDPOINT =
  '/api/signup/salesRepresentatives';

const CREATE_ACCOUNT_ENDPOINT =
  '/api/signup/createAccount';


function normalizeLocale(
  value,
) {
  const locale =
    String(
      value ||
      '',
    )
      .trim()
      .toLowerCase()
      .replace(
        /_/g,
        '-',
      )
      .split(
        '-',
      )[0];

  return (
    locale ||
    'ko'
  );
}


function getCurrentLocale() {
  const storageKeys = [
    'i18nextLng',
    'language',
    'lang',
  ];

  let storedLanguage =
    '';

  try {
    for (
      let index = 0;
      index < storageKeys.length;
      index += 1
    ) {
      const value =
        window.localStorage
          .getItem(
            storageKeys[
              index
            ],
          );

      if (
        value
      ) {
        storedLanguage =
          value;

        break;
      }
    }
  } catch (
    error
  ) {
    storedLanguage =
      '';
  }

  return normalizeLocale(
    storedLanguage ||
    document.documentElement.lang ||
    navigator.language ||
    'ko',
  );
}


export async function checkLoginIdDuplicate(
  loginId,
) {
  const response =
    await requestJson(
      `${CHECK_LOGIN_ID_ENDPOINT}?loginId=${encodeURIComponent(
        loginId,
      )}`,
      {
        method:
          'GET',
      },
    );

  return Boolean(
    response?.data?.duplicated,
  );
}


export async function getSalesRepresentativeList() {
  const response =
    await requestJson(
      SALES_REPRESENTATIVE_LIST_ENDPOINT,
      {
        method:
          'GET',
      },
    );

  if (
    response &&
    Array.isArray(
      response.data,
    )
  ) {
    return response.data;
  }

  return [];
}


export async function createMasterAccount(
  data,
) {
  const requestBody = {
    ...data,

    emailLocale:
      normalizeLocale(
        data?.emailLocale ||
        getCurrentLocale(),
      ),
  };

  return requestJson(
    CREATE_ACCOUNT_ENDPOINT,
    {
      method:
        'POST',

      body:
        JSON.stringify(
          requestBody,
        ),
    },
  );
}